import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loader from '../../../common/elements/Loader';
import RSSFeedItem from './RSSFeedItem';
import { DFPSlotsProvider, AdSlot } from "react-dfp";
import { DFP_SIZES } from "../../../../../client/components/common/adverts/googleDFP/ReactDFPHelper";
import { siteOfOriginHelper } from '../../../../helpers/genericHelpers';
export default class RSSFeedList extends Component {
	constructor(props) {
		super(props);
		this.state = { windowWidth : window.innerWidth };
	}

	componentDidMount = () => window.addEventListener( 'resize', this.updateWindowWidth )
	componentWillUnmount = () => window.removeEventListener( 'resize', this.updateWindowWidth )
	updateWindowWidth = () => this.setState({ windowWidth : window.innerWidth })

	buildAd( key ){
		return (
			<li key={ key } className="text-center margin-bottom padding-bottom advertisement">
				<DFPSlotsProvider autoLoad={ true } dfpNetworkId="/21672954868" adUnit='PTL.NED' collapseEmptyDivs={ true }>
					<AdSlot sizes={ DFP_SIZES.Banner } />
				</DFPSlotsProvider>
			</li>
		);
	}

	removeHTML = (arr) => {
		arr.map(rss => {
			let titles = rss.title
			if( titles.includes('href') ) {
				let tmp = document.createElement('div');
				tmp.innerHTML = titles;
				let title = tmp.querySelector('a').innerText;
				rss.title = title
			}
		})
	}

	buildRSS(){
		const siteOfOrigin = siteOfOriginHelper();

		this.removeHTML(this.props.rssArray);

		return this.props.rssArray.filter( rss => rss.country === siteOfOrigin ).map(( rss, i ) => {
			if(i < 21) {
                return <RSSFeedItem key={ rss.guid } rssFeed={ rss } />
			}
        });
	}

	render() {
		return (
			<React.Fragment>
				{ this.props.rssArray && this.props.rssArray[0] !== undefined ? this.buildRSS() : <Loader /> }
			</React.Fragment>
		)
	}
}

RSSFeedItem.propTypes = {
	rssArray: PropTypes.array,
	pathname: PropTypes.string
};



// WEBPACK FOOTER //
// src/client/components/site/features/homepage/RSSFeedList.js